module.exports = __webpack_public_path__ + "fonts/fa-thin-100.b6a6ab8b.woff2";